var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	3855: () => (loadStrictVersion("default", "rxjs", false, [2,7,8,2], () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(1340))))))),
	8675: () => (loadStrictVersion("default", "rxjs/operators", false, [2,7,8,2], () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9f2bd5"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(3620))))))),
	9975: () => (loadStrictVersion("default", "@angular/core", false, [4,21,1,3], () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("default-node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(9460))))))),
	3073: () => (loadStrictVersion("default", "@angular/core/primitives/signals", false, [4,21,1,3], () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022__weak_ref-chunk_mjs")]).then(() => (() => (__webpack_require__(6699))))))),
	4779: () => (loadStrictVersion("default", "@angular/core/primitives/di", false, [4,21,1,3], () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8513))))))),
	1751: () => (loadStrictVersion("default", "@angular/common/http", false, [4,21,1,3], () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs").then(() => (() => (__webpack_require__(6613))))))),
	2565: () => (loadStrictVersion("default", "@angular/common", false, [4,21,1,3], () => (__webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs").then(() => (() => (__webpack_require__(1352))))))),
	1335: () => (loadStrictVersion("default", "@angular/core/rxjs-interop", false, [4,21,1,3], () => (Promise.all([__webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(9074))))))),
	5345: () => (loadStrictVersion("default", "@angular/router", false, [4,21,1,3], () => (Promise.all([__webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs"), __webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs")]).then(() => (() => (__webpack_require__(7415))))))),
	5485: () => (load("default", "@app/utilities", false, () => (Promise.all([__webpack_require__.e("default-src_libs_utilities_index_ts"), __webpack_require__.e("src_libs_utilities_selection_boolean_pipe_ts-_b2fe1")]).then(() => (() => (__webpack_require__(7758))))))),
	7426: () => (load("default", "@app/crop-store", false, () => (Promise.all([__webpack_require__.e("default-node_modules_angular-architects_ngrx-toolkit_fesm2022_angular-architects-ngrx-toolkit_mjs"), __webpack_require__.e("default-src_libs_cropstore_index_ts")]).then(() => (() => (__webpack_require__(6080))))))),
	6109: () => (load("default", "@app/feature-flags", false, () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(1003))))))),
	7799: () => (load("default", "@app/crops-management", false, () => (Promise.all([__webpack_require__.e("default-node_modules_priva_components_fesm2022_priva-components-table_mjs"), __webpack_require__.e("default-src_libs_crops-management_index_ts")]).then(() => (() => (__webpack_require__(8483))))))),
	2677: () => (load("default", "@app/crop", false, () => (Promise.all([__webpack_require__.e("default-node_modules_lodash_lodash_js"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1622))))))),
	5379: () => (load("default", "@app/charts", false, () => (__webpack_require__.e("src_libs_charts_index_ts-_9a420").then(() => (() => (__webpack_require__(7893)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		3855
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		8675
	],
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		9975
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		3073,
		4779
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http-webpack_shari-5b3511": [
		1751,
		2565
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		1335
	],
	"default-node_modules_dayjs_dayjs_min_js-node_modules_priva_auth_fesm2022_priva-auth-current-u-cda83d": [
		5345
	],
	"default-webpack_sharing_consume_default_app_crop-store_app_crop-store-webpack_sharing_consume-f3cccc": [
		5485,
		7426
	],
	"default-src_app_app_config_ts-webpack_sharing_consume_default_app_feature-flags_app_feature-flags": [
		6109
	],
	"src_app_pages_crops_crops-routes_ts": [
		7799
	],
	"src_libs_crop_crop-detail_crop-detail_routes_ts": [
		2677
	],
	"default-webpack_sharing_consume_default_app_charts_app_charts": [
		5379
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}